import { api } from "lib/graphql/api"
import { query } from "lib/graphql/query"
import { gql } from "@apollo/client"

// FIQ-1658: fetch the uncapped affected-task lists behind the data-quality warnings.
// Recomputes the cost result server-side, so only call it on demand (export click).
export const getScenarioDataQualityTasks = api(async function scenarioDataQualityTasks({ scenarioId, variantId }) {
    return query(
        gql`
            query ScenarioDataQualityTasks($scenarioId: String!, $variantId: String) {
                scenarioDataQualityTasks(scenarioId: $scenarioId, variantId: $variantId)
            }
        `,
        { scenarioId, variantId },
        { returns: "scenarioDataQualityTasks" }
    )
})
